export const OEFR_TEMPLATE_ID = "53aa8912dec7e10d38f59f36"
export const OEFR_BUSINESS_UNIT_ID = "643aca7440dd867d9b2be30b"
